import { curry } from "ramda";
import selectColor from "./color";
import selectSpace from "./space";
import selectFontSize from "./fontSize";
import selectFont from "./font";
import selectWeight from "./fontWeight";
import selectRadius from "./radius";
import selectShadow from "./shadow";
import selectSpeed from "./speed";
import selectLineHeight from "./lineHeight";
export const color = curry((color, props) => {
    return selectColor(color, props.theme);
});
export const findColor = (props) => {
    return selectColor(props.c, props.theme);
};
export const findColorAlterIndex = (amount) => (props) => {
    const c = props.c;
    if (Array.isArray(c)) {
        const [type, index] = c;
        return selectColor([type, (index + amount)], props.theme);
    }
    return selectColor(props.c, props.theme);
};
export const space = curry((space, props) => {
    return selectSpace(space, props.theme);
});
export const findSpace = (propName) => (props) => {
    return space(props[propName], props);
};
export const fontSize = curry((size, props) => {
    return selectFontSize(size, props.theme);
});
export const findFontSize = (props) => {
    return fontSize(props.fs, props);
};
export const fontWeight = curry((weight, props) => {
    return selectWeight(weight, props.theme);
});
export const findFontWeight = (props) => {
    return fontWeight(props.fw, props);
};
export const font = curry((font, props) => {
    return selectFont(font, props.theme);
});
export const findFont = (props) => {
    return font(props.f, props);
};
export const radius = curry((radius, props) => {
    return selectRadius(radius, props.theme);
});
export const shadow = curry((shadow, props) => {
    return selectShadow(shadow, props.theme);
});
export const speed = curry((speed, props) => {
    return selectSpeed(speed, props.theme);
});
export const lineHeight = curry((lineHeight, props) => {
    return selectLineHeight(lineHeight, props.theme);
});
export const findLineHeight = (props) => {
    return lineHeight(props.lh, props);
};
//# sourceMappingURL=select.js.map